import { NgModule } from '@angular/core';
import { SharedModule } from 'app/shared/shared.module';
import { LineItemListComponent } from './line-item-list.component';
import { DragDropModule } from '@angular/cdk/drag-drop';

@NgModule({
  declarations: [
    LineItemListComponent
  ],
  imports: [
    SharedModule,
    DragDropModule
  ],
  exports: [
    LineItemListComponent
  ],
  providers: []
})
export class LineItemListModule { }
